import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import { property as t } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as s } from "../../../core/accessorSupport/decorators/subclass.js";
import { create as o } from "../../../geometry/support/aaBoundingRect.js";
import "../tiling/PagedTileQueue.js";
import r from "../tiling/TileInfoView.js";
import "../tiling/TileKey.js";
import "../tiling/TileQueue.js";
import "../tiling/TileStrategy.js";
import { LayerView2DMixin as i } from "./LayerView2D.js";
import { Display as l } from "./support/Display.js";
import n from "../../layers/LayerView.js";
import { RefreshableLayerView as a } from "../../layers/RefreshableLayerView.js";
var p = new Set(),
    c = [],
    h = [];

var u = function u(e, t, s, r, i, l, n) {
  var a = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [0, 0];
  var p = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : o();

  _classCallCheck(this, u);

  this.id = e, this.level = t, this.row = s, this.col = r, this.world = i, this.resolution = l, this.scale = n, this.coords = a, this.bounds = p;
};

var d = /*#__PURE__*/function (_a) {
  _inherits(d, _a);

  var _super = _createSuper(d);

  function d(e) {
    var _this;

    _classCallCheck(this, d);

    _this = _super.call(this, e), _this._tileMap = new Map(), _this.container = new l(_assertThisInitialized(_this)), _this.layer = null, _this.tiles = [];
    return _this;
  }

  _createClass(d, [{
    key: "_tileInfoView",
    get: function get() {
      var e = this.layer && this.layer.tileInfo;
      return e ? new r(e) : null;
    }
  }, {
    key: "attach",
    value: function attach() {}
  }, {
    key: "detach",
    value: function detach() {}
  }, {
    key: "requestRender",
    value: function requestRender() {
      this.container.requestRender();
    }
  }, {
    key: "tilesChanged",
    value: function tilesChanged(e, t) {}
  }, {
    key: "doRefresh",
    value: function () {
      var _doRefresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function doRefresh() {
        return _doRefresh.apply(this, arguments);
      }

      return doRefresh;
    }()
  }, {
    key: "isUpdating",
    value: function isUpdating() {
      return !1;
    }
  }, {
    key: "update",
    value: function update(e) {
      var t = this._tileInfoView,
          s = this.tiles;

      if (t) {
        var _o = t.getTileCoverage(e.state, 0),
            _r = _o.spans,
            _i = _o.lodInfo,
            _l = _i.level;

        if (_r.length) {
          var _iterator = _createForOfIteratorHelper(_r),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = _step.value,
                  _e = _step$value.row,
                  _t = _step$value.colFrom,
                  _n = _step$value.colTo;

              for (var _o2 = _t; _o2 <= _n; _o2++) {
                var _t2 = _i.normalizeCol(_o2),
                    _r2 = _i.getWorldForColumn(_o2),
                    _n2 = "".concat(_l, "/").concat(_e, "/").concat(_t2, "/").concat(_r2);

                if (!this._tileMap.has(_n2)) {
                  var _o3 = new u(_n2, _l, _e, _t2, _r2, _i.resolution, _i.scale);

                  _i.getTileCoords(_o3.coords, _o3, !1), _i.getTileBounds(_o3.bounds, _o3, !0), this._tileMap.set(_n2, _o3), s.push(_o3), c.push(_o3);
                }

                p.add(_n2);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }

      for (var _o4 = s.length - 1; _o4 >= 0; _o4--) {
        var _e2 = s[_o4];
        p.has(_e2.id) || (s.splice(_o4, 1), h.push(_e2), this._tileMap.delete(_e2.id));
      }

      (c.length || h.length) && (this.tilesChanged(c, h), c.length = h.length = 0), p.clear(), this.requestRender();
    }
  }, {
    key: "moveStart",
    value: function moveStart() {}
  }, {
    key: "viewChange",
    value: function viewChange() {
      this.requestUpdate();
    }
  }, {
    key: "moveEnd",
    value: function moveEnd() {}
  }]);

  return d;
}(a(i(n)));

e([t()], d.prototype, "_tileInfoView", null), e([t()], d.prototype, "layer", void 0), d = e([s("esri.views.2d.layers.BaseLayerView2D")], d);
var m = d;
export { m as default };